// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--BXluv";
export var docsImage = "styles-module--docs-image--A61PI";
export var caption = "styles-module--caption--E1X1z";
export var Left = "styles-module--Left--TATg7";
export var Middle = "styles-module--Middle--OTOW+";
export var Right = "styles-module--Right--25uuW";